import React from "react";
const Lists = () => {

    return (
        <div id="lists">
            <h3>Lists</h3>

            <p>
                Lists blocks allow you to create and manipulate arrays of values. This is useful for organizing data, performing operations on collections, and building dynamic content.
            </p>

            <div className="imageContainer">
                <img src="/images/lists.png" alt="Lists Overview" />
            </div>

            <ul>

                <li>
                    <p>
                        <strong>Create list with</strong> - allows you to create a list with specific items.
                    </p>
                </li>

                <li>
                    <p>
                        <strong>Create list with item repeated</strong> - allows you to define a list with an item repeated a specified number of times.
                    </p>
                </li>

                <li>
                    <p>
                        <strong>Length of list</strong> - returns the number of items in a list.
                    </p>
                </li>

                <li>
                    <p>
                        <strong>Is list empty</strong> - checks whether a list has no items.
                    </p>
                </li>

                <li>
                    <p>
                        <strong>In list first occurrence or last occurrence</strong> - helps you locate the first or last occurrence of a value in a list. This block is useful for checking if a value occurs in a list.
                    </p>
                </li>

                <li>
                    <p>
                        <strong>In list get/remove</strong> - lets you get, get and remove, or remove an item at the specified index in/from the list. You can get the first, last, or any indexed item. The first item of the list has index 1.
                    </p>
                </li>


                <li>
                    <p>
                        <strong>Set/insert item in list</strong> - allows you to set a value at a specific index or insert a new item at that index.
                    </p>
                </li>

                <li>
                    <p>
                        <strong>Get sublist</strong> - extracts part of a list. You can get a sublist from the specified index to the end of the list, from one index to another, or from the first item to the specified index.
                    </p>
                </li>

                <li>
                    <p>
                        <strong>Make list from text</strong> - splits a string into a list using a delimiter.
                    </p>
                </li>

                <li>
                    <p>
                        <strong>Sort list</strong> - allows you to sort items numerically, alphabetically, or alphabetically ignoring case. You can choose ascending or descending order.
                    </p>
                </li>


                <li>
                    <p>
                        <strong>JSON</strong> - lets you define a JSON object with key-value pairs.
                    </p>
                </li>

                <li>
                    <p>
                        <strong>Get " " from JSON object</strong> - retrieves the value for a specified key from a JSON object.
                    </p>
                </li>

                <li>
                    <p>
                        <strong>From JSON object " " get</strong> - retrieves any nested value within a JSON object. 
                    </p>
                    <p>
                        To inform the block of the expected structure of the JSON object, start by clicking <b>Set Schema</b>. Then, in the Set Schema window, paste a sample JSON object with the same structure as the JSON object you would like to extract a nested value from. 
                        Click <b>Apply</b> to set the JSON structure for the block.
                    </p>
                    <p>
                        You can now use the +/- buttons to navigate through the levels of the JSON structure, and you can use the resulting dropdowns to select the key or index for which you wish to retrieve the value.
                    </p>
                </li>

                <li>
                    <p>
                        <strong>Update JSON object set " " equal to " "</strong> - sets the value for a specified key in a JSON object.
                    </p>
                </li>

                <li>
                    <p>
                        <strong>Convert JSON object " " to text</strong> - converts the provided JSON object into its text representation.
                    </p>
                </li>

            </ul>
        </div >
    );

}

export default Lists; 
